import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'
import {
    SkeletonButton,
    SkeletonBadge,
    SkeletonText,
    SkeletonTitle,
} from '@/components/ui/skeleton-base'

const ProductDetailsSkeleton = () => (
    <div className="container mx-auto py-8">
        <div className="mb-6 flex items-center justify-between">
            <div className="flex items-center gap-2">
                <Skeleton className="h-10 w-10" />
                <SkeletonTitle className="w-48" />
            </div>
        </div>

        <Card className="mb-6">
            <CardHeader className="pb-4">
                <div className="flex items-start justify-between">
                    <div className="space-y-2">
                        <SkeletonTitle className="w-64" />
                        <SkeletonText className="w-48" />
                    </div>
                    <SkeletonBadge />
                </div>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
                    {[...Array(3)].map((_, i) => (
                        <div key={i} className="flex flex-col space-y-2">
                            <SkeletonText className="w-24" />
                            <SkeletonTitle className="w-32" />
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>

        <div className="w-full">
            <div className="mb-6 inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground w-full">
                <div className="grid w-full grid-cols-2 gap-1">
                    <Skeleton className="h-9" />
                    <Skeleton className="h-9" />
                </div>
            </div>

            <div className="space-y-6">
                <Card>
                    <CardHeader>
                        <SkeletonTitle className="w-40" />
                    </CardHeader>
                    <CardContent>
                        <div className="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
                            {[...Array(6)].map((_, i) => (
                                <div key={i} className="space-y-2">
                                    <SkeletonText className="w-24" />
                                    <SkeletonText className="w-full" />
                                </div>
                            ))}
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    </div>
)

export default ProductDetailsSkeleton

